module.exports = __webpack_public_path__ + "images/48c17295c2be224266c6bca6f4d4ef19762fe372051a3466aa5241fedcdc3ce4.svg";